import { Dispatch } from 'redux';
import { getStylesForLearner } from '../utils/api';

interface Style {
  _id: string;
  createdAt: string;
  file: string;
  updatedAt: string;
}

type StyleOrNone = Style | void;

export const actions = {
  UPDATE: 'customStyles/update',
};

interface StyleAction {
  type: typeof actions.UPDATE;
  payload: StyleOrNone;
}

type StyleActionTypes = StyleAction;

export const update = (payload: Style) => {
  return {
    type: actions.UPDATE,
    payload,
  };
};

export const loadStyles = () => async (dispatch: Dispatch) => {
  try {
    const response = await getStylesForLearner();
    if (response.data && response.data.length) {
      dispatch(update(response.data[0]));
    }
  } catch (error) {
    console.error(error);
  }
};

const initialState = {
  file: '',
  _id: '',
};

export const customStylesReducer = (
  state = initialState,
  action: StyleActionTypes
) => {
  switch (action.type) {
    case actions.UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
